
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "PermissionManagement"
})
export default class extends Vue {
}
